import Vue from "vue"
import Vuex from "vuex"
import isAfter from 'date-fns/isAfter'
import parseISO from 'date-fns/parseISO'
import axios from 'axios'
import { log } from '@/_framework/entries/logging'

const isServerSide = typeof window === "undefined"
const envConfig = isServerSide ? null : window._vueContext.envConfig

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: () => ({
      publicAccessToken: {
        token: null,
        expires: null
      },
      store: null,
      selectedDeliveryMethod: 0,
      storeSearchQuery: '',
      storePickerKey: 0,
      linkToOnline: 'https://www.ica.se/handla'
    }),
    mutations: {
      SET_TOKEN (state, tokenResponse) {
        state.publicAccessToken.token = tokenResponse.publicAccessToken
        state.publicAccessToken.expires = tokenResponse.tokenExpires
      },
      SET_STORE (state, store) {
        state.store = store
      },
      CLEAR_STORE (state) {
        state.store = null
      },
      SET_DELIVERY_METHOD (state, selectedDeliveryMethod) {
        state.selectedDeliveryMethod = selectedDeliveryMethod == 1 ? "homeDelivery" : "pickup"
        localStorage.setItem('grocerybagDeliveryMethod', selectedDeliveryMethod)
      },
      CLEAR_DELIVERY_METHOD (state) {
        state.selectedDeliveryMethod = 0
        localStorage.setItem('grocerybagDeliveryMethod', 0)
      },
      SET_STORE_SEARCH_QUERY (state, searchQuery) {
        state.storeSearchQuery = searchQuery
      },
      CLEAR_STORE_SEARCH_QUERY (state) {
        state.storeSearchQuery = ''
      },
      SHOW_STORE_PICKER (state) {
        state.storePickerKey += 1
      },
      SET_NEW_ONLINE_LINK (state, onlineLink) {
        state.linkToOnline = onlineLink
      }
    },
    actions: {
      async handleStoreChangedEvent ( { state, commit }, event) {
        const eventStoreId = event.detail?.store?.Id
        const currentGrocerybagStoreId = state.store?.bmsId
        if(eventStoreId !== currentGrocerybagStoreId)
        {
          axios.get(`${envConfig.baseUrl}/api/grocerybag/stores/bms/${eventStoreId}`)
          .then(data => {
              const { store } = data.data
              const storedDeliveryMethod = localStorage.getItem('grocerybagDeliveryMethod') ? parseInt(localStorage.getItem('grocerybagDeliveryMethod')) : null
              const availableStoredDeliveryMethod = store.deliveryMethods.includes(storedDeliveryMethod) ? storedDeliveryMethod : 0
              const deliveryMethod = storedDeliveryMethod === null ? 0 : availableStoredDeliveryMethod
              commit('SET_STORE', store)
              commit('SET_DELIVERY_METHOD', deliveryMethod)
            }).catch((error) => {
              if(error.response.status === 404) {
                return
              } else {
                log(`fetch getGrocerybagStore error: ${error.response.status} ${error.response.message}`)
              }
            })
        }
      },
      setGlobalStore (_vuex, grocerybagStore) {
        axios.get(`${envConfig.baseUrl}/api/store/searchbyid?query=${grocerybagStore.bmsId}&useaccountnr=false`)
        .then(({ data }) => {
          const globalStore = data.Documents.find(s => s.Id === grocerybagStore.bmsId)
          if(!globalStore) {
            throw new Error('setGlobalStore: Cant find store ', grocerybagStore.bmsId)
          }
          const onlineEvent = new CustomEvent('groceryBagStoreChange', {
            detail: {
              onlineUrl: globalStore.OnlineUrl,
              store: globalStore
            }
          })
          document.dispatchEvent(onlineEvent)
        })
        .catch((error) => console.error(error))
      },
      setGrocerybagStore ({ commit }, { grocerybagStore, deliveryMethod }) {
        commit('SET_STORE', grocerybagStore)
        commit('SET_DELIVERY_METHOD', deliveryMethod)
      },
      getPublicAccessToken ({ state, dispatch, commit }) {
        if(state.publicAccessToken.token) {
          let tokenExpires = parseISO(state.publicAccessToken.expires)
  
          if (isAfter(tokenExpires, new Date())) {
            // Use current token if not expired
            return state.publicAccessToken.token
          }
        }
  
        // No non expired token existed in store, fetch new or renew
        return new Promise((resolve) => {
          dispatch('setPublicAccessToken').then((tokenResponse) => {
            // Save tokenResponse to store and return token to caller
            commit('SET_TOKEN', tokenResponse)
            resolve(tokenResponse.publicAccessToken)
          })
        })
      },
      async setPublicAccessToken () {
        let baseUrl = ""
        if (window && window._vueContext && window._vueContext.envConfig) {
          baseUrl = window._vueContext.envConfig.baseUrl
        }
  
        try {
          const response = await fetch(`${baseUrl}/e11/public-access-token`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
  
          if (response.status >= 200 && response.status < 300) {
            return await response.json()
          }
        } catch (error) {
          console.error("Failed setting public access token", error)
        }
      }
    },
    modules: {}
  })
}
